//  import VideoPopupPlay from '~/js/modules/video-popup';

// VIDEO POPUP
export default function VideoPopupPlay(linkClass) {
    this.link = document.querySelectorAll(`.${linkClass}`);

    this._createModalWindow = (link) => {
        this.overlay = document.createElement('div');
        this.overlay.classList.add('video__overlay');
        this.videoWrapper = document.createElement('div');
        this.videoWrapper.classList.add('video__wrapper');
        this.videoClose = document.createElement('div');
        this.videoClose.classList.add('video__close');
        this.videoCloseIcon = document.createElement('i');
        this.videoCloseIcon.classList.add('ic');
        this.videoCloseIcon.classList.add('ic-close');
        this.iframeWrapper = document.createElement('div');
        this.iframeWrapper.classList.add('video__iframe-wrapper');
        this.iframeWrapper.innerHTML = `<iframe src="https://www.youtube.com/embed/${link}?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
        this.videoWrapper.appendChild(this.iframeWrapper);
        this.videoClose.appendChild(this.videoCloseIcon);
        this.videoWrapper.appendChild(this.videoClose);
        this.overlay.appendChild(this.videoWrapper);
        document.body.appendChild(this.overlay);
    };

    for(const link of this.link) {
        const linkHref = link.href;
        const partLinkPos = linkHref.indexOf('=') + 1;
        const partLink = linkHref.slice(partLinkPos, partLinkPos + 11);

        link.addEventListener('click', e => {
            const isMobile = window.innerWidth < 768;
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            const isAndroid = /Android/i.test(navigator.userAgent);

            e.preventDefault();
            this._createModalWindow(partLink);
            if (!isMobile && !isIOS && !isAndroid) {
                document.body.style.overflow = 'hidden';
                document.body.style.marginRight = '17px';
                document.querySelector('.js-header').style.right = '17px';
            }

            this.overlay.addEventListener('click', () => {
                this.overlay.parentNode.removeChild(this.overlay);
                document.body.removeAttribute('style');
                document.querySelector('.js-header').removeAttribute('style');
            });
        });
    }
}
